import { Fragment } from 'react';
import { cardSrc, parseTeenCards, parseRdesc } from './resultParsers';

const WINNER_ICON = 'https://wver.sprintstaticdata.com/v230/static/front/img/winner.png';

// Teenpatti 1-day family result (teen / vteen / pteen and instant teen3 / teen32 / teen33).
// Reference layout: h4 sits OUTSIDE .casino-result-cards, and the winner icon is
// the first item inside it (no d-inline-block wrapper).
export default function TeenOneDayResult({ detail }) {
  const cards = parseTeenCards(detail?.card);
  const rdesc = parseRdesc(detail?.rdesc);
  const winValue = detail?.win;
  const winner = detail?.winnat || rdesc.winner || '';
  const isAWinner = winValue === '1' || winner === 'Player A';
  const isBWinner = winValue === '2' || winner === 'Player B';

  const side = (label, hand, isWinner) => (
    <div className="casino-result-content-item text-center">
      <h4>{label}</h4>
      {' '}
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_ICON} className="winner-icon" alt="Winner" />
          </div>
        )}
        {hand.map((code, i) => (
          <Fragment key={i}>
            {' '}
            <div className="casino-result-cards-item">
              <img src={cardSrc(code)} alt={code} />
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          {side('Player A', cards.playerA, isAWinner)}
          {' '}
          <div className="casino-result-content-diveder"></div>
          {' '}
          {side('Player B', cards.playerB, isBWinner)}
        </div>
      </div>
      {' '}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            {' '}
            <div>{winner || (isAWinner ? 'Player A' : isBWinner ? 'Player B' : '')}</div>
          </div>
          {rdesc.oddEven && (
            <div className="casino-result-desc-item">
              <div>Odd/Even</div>
              {' '}
              <div>{rdesc.oddEven}</div>
            </div>
          )}
          {rdesc.consecutive && (
            <div className="casino-result-desc-item">
              <div>Consecutive</div>
              {' '}
              <div>{rdesc.consecutive}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
